import { useEffect, useState } from "react";

import { useAppSelector } from "~/hooks/reduxHooks";
import useModuleEnabledState from "~/hooks/useModuleEnabledState";
import getLastModuleKey from "~/pwa/getLastModuleKey";
import { type InstallableApp } from "~/pwa/installableApps";
import isStandaloneDisplay from "~/pwa/isStandaloneDisplay";
import launchSession from "~/pwa/launchSession";
import resolveLaunchModule from "~/pwa/resolveLaunchModule";

interface LaunchModuleState {
	isPending: boolean;
	module: InstallableApp | null;
}

launchSession.begin();

const settled = (module: InstallableApp | null): LaunchModuleState => ({ isPending: false, module });

const useLaunchModule = (): LaunchModuleState => {
	const isWideScreen = useAppSelector((state) => state.layout.isWideScreen);
	const { enabledByKey, isSettled } = useModuleEnabledState();
	const [isFirstLaunch] = useState(() => launchSession.isPending() && isStandaloneDisplay() && !isWideScreen);

	useEffect(() => {
		if (!isFirstLaunch || isSettled) launchSession.complete();
	}, [isFirstLaunch, isSettled]);

	if (!isFirstLaunch) return settled(null);
	if (!isSettled) return { isPending: true, module: null };

	return settled(resolveLaunchModule({ enabledByKey, lastModuleKey: getLastModuleKey() }));
};

export type { LaunchModuleState };
export default useLaunchModule;
